
<div class="d-flex justify-content-center loader flex-column align-items-center" *ngIf="loading">
    <div>
      <mat-spinner color="accent"></mat-spinner>
    </div>
  </div>
  <div class="scrollable">
    <app-calendar [location]="location" (openSideNav)="openSideNav($event)" [loading]="loading" (updateParentLoader)="updateLoader($event)"></app-calendar>
  </div>